// extracted by mini-css-extract-plugin
export default {"link":"RK-z","disabled":"SK-z"};